import classNames from "classnames"

export default function Bubble({ children, className = 'inline' }) {
    return <div className={classNames("uppercase whitespace-nowrap bg-red-500 bg-opacity-30 text-red-500 rounded-xl p-1 px-4 text-sm", className)}>
        {children}
    </div>
}